<template>
  <div id="app">
    <PowerballGame />
  </div>
</template>

<script>
import PowerballGame from "./views/PowerballGame.vue";

export default {
  name: "App",
  components: {
    PowerballGame,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: white;
}
</style>
